module.exports = __webpack_public_path__ + "static/media/green_animal_mammals.681906ca.png";